<div class="repair-container">
  <div class="repair-topbar">
    <div class="topbar-left">
      <h1>
        Repair History
        <small>Track all item repair and maintenance records</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Maintenance</span> / <span class="current">Repair History</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Filter by item name..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)" />
      </div>
      <button class="btn btn-outline btn-sm" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-outline btn-sm" (click)="printPage()">
        <i class="bi bi-printer"></i> Print
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-wrench"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Repairs</div>
        <div class="stat-value">{{ historyStats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Completed</div>
        <div class="stat-value">{{ historyStats().completed }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Warranty</div>
        <div class="stat-value">{{ historyStats().warranty }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-exclamation-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Filtered</div>
        <div class="stat-value">{{ filteredHistory().length }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tag"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
          <option value="">All Status</option>
          <option value="completed">Completed</option>
          <option value="warranty">Warranty</option>
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-tools"></i> Type</label>
        <select [ngModel]="typeFilter()" (ngModelChange)="typeFilter.set($event)">
          <option value="">All Types</option>
          <option value="repair">Repair</option>
          <option value="maintenance">Maintenance</option>
          <option value="inspection">Inspection</option>
          <option value="service">Service</option>
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredHistory().length }} records</span>
      <button
        type="button"
        class="btn btn-outline btn-sm"
        [class.active]="showMoreFilters()"
        (click)="toggleMoreFilters()"
      >
        <i class="bi bi-funnel"></i> More Filters
      </button>
    </div>
  </div>

  @if (showMoreFilters()) {
    <div class="filter-bar filter-bar-advanced">
      <div class="filter-left">
        <div class="filter-group">
          <label><i class="bi bi-calendar"></i> Completed From</label>
          <input
            type="date"
            [ngModel]="completedFrom()"
            (ngModelChange)="completedFrom.set($event)"
          />
        </div>
        <div class="filter-group">
          <label><i class="bi bi-calendar"></i> Completed To</label>
          <input
            type="date"
            [ngModel]="completedTo()"
            (ngModelChange)="completedTo.set($event)"
          />
        </div>
        <div class="filter-group">
          <label><i class="bi bi-person"></i> Technician</label>
          <input
            type="text"
            placeholder="Search technician..."
            [ngModel]="technicianFilter()"
            (ngModelChange)="technicianFilter.set($event)"
          />
        </div>
      </div>
      <div class="filter-right">
        <button type="button" class="btn btn-outline btn-sm" (click)="clearMoreFilters()">
          Clear advanced filters
        </button>
      </div>
    </div>
  }

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Item</th>
            <th>Type</th>
            <th>Description</th>
            <th>Cost</th>
            <th>Completed</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (entry of filteredHistory(); track entry.id) {
            <tr>
              <td><span class="repair-id">{{ entry.jobId }}</span></td>
              <td>
                <div class="item-info">
                  <span class="item-icon"><i class="bi bi-box-seam"></i></span>
                  <div>
                    <div class="item-name">{{ entry.assetName }}</div>
                    <div class="item-id">{{ entry.assetId }}</div>
                  </div>
                </div>
              </td>
              <td><span class="type-badge" [class]="entry.repairType">{{ entry.repairType | titlecase }}</span></td>
              <td>{{ entry.description }}</td>
              <td>{{ formatCurrency(entry.cost) }}</td>
              <td>{{ formatDate(entry.completedDate) }}</td>
              <td><span class="status-badge" [class]="entry.status">{{ entry.status | titlecase }}</span></td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action" title="View details" (click)="openViewModal(entry)">
                    <i class="bi bi-eye"></i>
                  </button>
                  @if (auth.hasPermission('delete_orders')) {
                  <button type="button" class="btn-action delete" title="Delete entry" (click)="deleteEntry(entry)">
                    <i class="bi bi-trash"></i>
                  </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>1</span> to <span>{{ filteredHistory().length }}</span> of <span>{{ filteredHistory().length }}</span> records
    </div>
  </div>
</div>

@if (selectedRecord(); as record) {
  <div class="modal-overlay" [class.open]="showViewModal()" (click)="closeModalOnBackdrop($event)">
    <div class="modal modal-large">
      <div class="modal-header">
        <h2><i class="bi bi-eye"></i> Repair Details</h2>
        <button class="close-btn" (click)="closeViewModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="detail-grid">
          <div class="detail-field">
            <label>Job ID</label>
            <span>{{ record.jobId }}</span>
          </div>
          <div class="detail-field">
            <label>Item</label>
            <span>{{ record.assetId }} - {{ record.assetName }}</span>
          </div>
          <div class="detail-field">
            <label>Type</label>
            <span><span class="type-badge" [class]="record.repairType">{{ record.repairType | titlecase }}</span></span>
          </div>
          <div class="detail-field">
            <label>Status</label>
            <span><span class="status-badge" [class]="record.status">{{ record.status | titlecase }}</span></span>
          </div>
          <div class="detail-field">
            <label>Description</label>
            <span>{{ record.description }}</span>
          </div>
          <div class="detail-field">
            <label>Cost</label>
            <span>{{ formatCurrency(record.cost) }}</span>
          </div>
          <div class="detail-field">
            <label>Completed Date</label>
            <span>{{ formatDate(record.completedDate) }}</span>
          </div>
          <div class="detail-field">
            <label>Technician</label>
            <span>{{ record.technician }}</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" (click)="closeViewModal()">Close</button>
        <button class="btn btn-outline" (click)="printPage()"><i class="bi bi-printer"></i> Print</button>
      </div>
    </div>
  </div>
}

<div class="toast-container" [class.show]="showToast()">
  <div class="toast success">
    <div class="toast-icon">
      <i class="bi bi-check-circle-fill"></i>
    </div>
    <div class="toast-content">
      <div class="toast-title">Success!</div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
